import { Search as SearchIcon } from '@mui/icons-material';
import {
  Box,
  CircularProgress,
  TextField,
  Typography,
} from '@mui/material';
import { StudioPage } from '../../../page-templates/StudioPage';
import styles from './Search.styles';
import { SearchResults } from './SearchResults';
import { useSearchWithFallback } from './useSearchWithFallback';

export const Search = () => {
  const {
    searchQuery,
    setSearchQuery,
    searchResults,
    loading,
    error,
    hasSearched,
    fallbackSuggestion,
    fallbackClips,
    fallbackLoading,
    semanticResults,
    semanticSearchTerms,
    semanticLoading,
  } = useSearchWithFallback();

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);
  };

  return (
    <StudioPage>
      <Box sx={styles.container}>
        <Box sx={styles.headerSection}>
          <Typography variant="h4" sx={styles.title}>
            Search
          </Typography>
          <Typography variant="body1" sx={styles.subtitle}>
            Search through your collections and clips
          </Typography>
        </Box>

        <Box sx={styles.searchSection}>
          <TextField
            fullWidth
            placeholder="Search clips and collections..."
            value={searchQuery}
            onChange={handleSearchChange}
            InputProps={{
              startAdornment: (
                <SearchIcon sx={styles.searchIcon} />
              ),
            }}
            sx={styles.searchInput}
          />
        </Box>

        {loading && (
          <Box sx={styles.loadingContainer}>
            <CircularProgress size={24} />
            <Typography variant="body2" sx={styles.loadingText}>
              Searching...
            </Typography>
          </Box>
        )}

        {!loading && error && (
          <Box sx={styles.errorContainer}>
            <Typography sx={styles.errorText}>{error}</Typography>
          </Box>
        )}

        {!loading && !error && hasSearched && searchResults && (
          <SearchResults
            searchQuery={searchQuery}
            searchResults={searchResults}
            fallbackSuggestion={fallbackSuggestion}
            fallbackClips={fallbackClips}
            fallbackLoading={fallbackLoading}
            semanticResults={semanticResults}
            semanticSearchTerms={semanticSearchTerms}
            semanticLoading={semanticLoading}
          />
        )}

        {!loading && !error && !hasSearched && (
          <Box sx={styles.emptyStateContainer}>
            <Typography variant="body1" sx={styles.emptyStateText}>
              Enter a search term to find clips and collections
            </Typography>
          </Box>
        )}
      </Box>
    </StudioPage>
  );
};
